import React from 'react';
import { Dialog } from '@mui/material';
import { useCSVReader } from 'react-papaparse';

const ImportModal = ({ open, onModalClose }) => {
  const { CSVReader } = useCSVReader();

  const handleOnDrop = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const handleOnRemoveFile = (data) => {
    console.log('---------------------------');
    console.log(data);
    console.log('---------------------------');
  };

  return (
    <Dialog open={open} onClose={onModalClose}>
      <div className="p-8 text-center w-360 mx-auto">
        <CSVReader
          onDrop={handleOnDrop}
          onError={handleOnError}
          addRemoveButton
          onRemoveFile={handleOnRemoveFile}
        >
          <span>Drop CSV file here or click to upload.</span>
        </CSVReader>
      </div>
    </Dialog>
  );
};

export default ImportModal;
